<template>
  <Layout>
    <div id="redoc-container"></div>
  </Layout>
</template>

<style>
.api-info p {
  margin-top: 20px;
  text-align: justify;
}
.api-info h1 {
  display: none;
}
div[id*="operation"] h3 {
  margin-top: 20px;
}
div[id*="section"] p {
  margin-top: 20px;
  text-align: justify;
}
.menu-content img {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>

<script>
import { swaggerUrl } from "@/mixins";

export default {
  mixins: [swaggerUrl],
  created() {
    this.$loadScript(
      "https://cdn.jsdelivr.net/npm/redoc@next/bundles/redoc.standalone.js"
    ).then(() => {
      const url = this.swaggerUrl();

      if (!window.__PRERENDER_INJECTED) {
        /*global Redoc*/
        /*eslint no-undef: "error"*/

        Redoc.init(
          url,
          {
            theme: { colors: { main: "#dd5522" } },
            hideDownloadButton: true,
            expandResponses: "all"
          },
          document.getElementById("redoc-container")
        );
      }
    });
  }
};
</script>
